import { Button, Flex, Popover, Text } from "@mantine/core";
import { useState } from "react";
import type { FC } from "react";
import { FaRegBell } from "react-icons/fa";
import { NotificationListModalMemo } from "src/component/pageComponent/Notification/NotificationList/NotificationListModal";
import { NotificationUserContext } from "src/component/pageComponent/Notification/Provider/NotificationUserProvider";

import styles from "./NotificationBadgeCount.module.scss";

const NotificationBadge: FC<{
  hasNew?: boolean;
  badgeSize?: number;
  badgeCount: number;
}> = ({ hasNew, badgeSize = 25, badgeCount }) => {
  const [open, setOpen] = useState(false);

  const onOpen = () => {
    setOpen(true);
  };

  return (
    <Flex sx={{ position: "relative" }}>
      <Popover opened withArrow>
        <Popover.Target>
          <Button
            sx={{ background: "none", height: "auto", padding: 0, margin: 0 }}
            onClick={onOpen}
          >
            <FaRegBell size={badgeSize} color="#2D3336" />
            <Flex
              className={styles.badgeCount}
              sx={{
                marginTop: -5,
                marginRight: -5,
                minWidth: badgeSize * 0.7,
                height: badgeSize * 0.7,
                background: badgeCount > 0 ? "red" : "transparent",
                borderRadius: badgeSize * 0.35,
              }}
              align={"center"}
            >
              <Text
                w={"100%"}
                align="center"
                color="#fff"
                style={{ fontSize: badgeSize * 0.3, padding: 2 }}
              >
                {badgeCount > 99 ? "99+" : badgeCount}
              </Text>
            </Flex>
          </Button>
        </Popover.Target>
        {hasNew && !open && <Popover.Dropdown>新しい通知</Popover.Dropdown>}
      </Popover>
      {open && (
        <NotificationListModalMemo opened onClose={() => setOpen(false)} />
      )}
    </Flex>
  );
};

export const NotificationBadgeCount: FC<{ badgeSize?: number }> = ({
  badgeSize = 25,
}) => {
  return (
    <NotificationUserContext.Consumer>
      {({ badgeCount, hasNew }) => (
        <NotificationBadge
          hasNew={hasNew}
          badgeCount={badgeCount}
          badgeSize={badgeSize}
        />
      )}
    </NotificationUserContext.Consumer>
  );
};
